// extracted by mini-css-extract-plugin
export default {"pill":"h4VJy","pillText":"ziWEf","switchContainer":"L4evP","selectedSide":"FOfM6"};